"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingParenthesesError = void 0;
const PredicateStringParsingError_1 = require("./PredicateStringParsingError");
class MissingParenthesesError extends PredicateStringParsingError_1.PredicateStringParsingError {
    constructor(amountOfOpeningParentheses, amountOfClosingParentheses) {
        let message;
        if (amountOfOpeningParentheses > amountOfClosingParentheses) {
            message = 'Closing ")" is missing.';
        }
        else {
            message = 'Opening ")" is missing';
        }
        super(message);
    }
}
exports.MissingParenthesesError = MissingParenthesesError;
//# sourceMappingURL=MissingParenthesesError.js.map